import Link from 'next/link'
import { BuddifyMark } from '@/components/ui/buddify-mark'
import { cn } from '@/lib/utils'

interface BuddifyLogoProps {
  variant?: 'light' | 'dark' | 'auto'
  size?: 'sm' | 'md' | 'lg'
  className?: string
  href?: string
}

export function BuddifyLogo({
  variant = 'auto',
  size = 'md',
  className,
  href = '/',
}: BuddifyLogoProps) {
  const sizeClasses = {
    sm: {
      mark: 'size-5',
      text: 'text-base',
    },
    md: {
      mark: 'size-7',
      text: 'text-xl',
    },
    lg: {
      mark: 'size-9',
      text: 'text-2xl',
    },
  }

  const logo = (
    <span
      role="img"
      aria-label="Buddify"
      className={cn(
        'flex items-center font-heading font-bold leading-none tracking-tight',
        sizeClasses[size].text,
        variant === 'auto' ? 'text-ink' : variant === 'dark' ? 'text-white' : 'text-primary-900',
        className
      )}
    >
      <BuddifyMark variant={variant} className={sizeClasses[size].mark} />
      <span aria-hidden="true" className="-ml-1 mt-0.5">uddify</span>
    </span>
  )

  if (href) {
    return (
      <Link href={href} className="flex items-center" aria-label="Buddify home">
        {logo}
      </Link>
    )
  }

  return logo
}
